import DataService from "@/core/base/service/data.service";
import { IUser } from "@/shared/model/user.model";

export default class UserService extends DataService<IUser> {
  protected baseApiUrl: string = "api/admin/users";
}